import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "admin.settings.video.background.label",
    defaultMessage: "Video background",
    description: "Title for video settings page",
  },
});
